import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormProvider, useForm } from 'react-hook-form'

import { Button, Alert } from 'components/Elements'
import { validationSchema } from './validation'
import { TextInput, FormFieldController } from 'components/FormElements'
import { useFormSubmit } from 'hooks'
import { EditorField } from 'features/rich-text-editor/components/FormElements'

export const QuestionForm = ({ initialValues, ...props }) => {
  const { t } = useTranslation()

  const defaultValues = {
    question: '',
    answer: '',
    ...initialValues,
  }

  const methods = useForm({
    defaultValues,
    resolver: yupResolver(validationSchema),
  })

  const {
    control,
    handleSubmit,
    setError,
    formState: { isSubmitting },
  } = methods

  const { error: submitError, onSubmit: onFormSubmit } = useFormSubmit({
    submit: props.onSubmit,
    setError,
  })

  const onSubmit = async data => {
    try {
      await onFormSubmit(data)
    } catch (error) {}
  }

  return (
    <>
      <FormProvider {...methods}>
        {submitError && <Alert type={'error'}>{submitError?.message || t('error')}</Alert>}

        <form onSubmit={handleSubmit(onSubmit)}>
          <FormFieldController
            name={'question'}
            control={control}
            component={TextInput}
            id={'question'}
            label={t('question')}
            placeholder={t('question')}
          />

          <FormFieldController
            name={'answer'}
            control={control}
            component={EditorField}
            id={'answer'}
            label={t('answer')}
            placeholder={t('answer')}
            config={{
              removePlugins: ['EasyImage', 'ImageUpload', 'MediaEmbed', 'Table'],
              toolbar: {
                removeItems: ['uploadImage', 'mediaEmbed', 'insertTable'],
              },
            }}
          />

          <div className="mt-3 pt-3">
            <div className="text-center">
              <Button type={'submit'} disabled={isSubmitting} loading={isSubmitting}>
                {t('save')}
              </Button>
            </div>
          </div>
        </form>
      </FormProvider>
    </>
  )
}

QuestionForm.propTypes = {
  onSubmit: PropTypes.func,
  initialValues: PropTypes.object,
}
